import { useMemo } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { isEmrRoute } from "./emrRoute";

/** Patient ids from EMR encounter URL when the global AI drawer is used outside EmrContext. */
export function useEmrUrlPatientIds() {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    if (!isEmrRoute(pathname)) {
      return {
        isOnEmr: false,
        encounterId: null as number | null,
        patientMasterId: null as number | null,
        patientId: null as string | null,
      };
    }
    const match = pathname.match(/\/patient-care\/emr\/(\d+)\/(\d+)/i);
    const encounterId = match ? Number(match[1]) : null;
    const patientMasterId = match ? Number(match[2]) : null;
    const emrNo = searchParams.get("emrno");
    return {
      isOnEmr: true,
      encounterId: Number.isFinite(encounterId) ? encounterId : null,
      patientMasterId: Number.isFinite(patientMasterId) ? patientMasterId : null,
      patientId: emrNo?.trim() || null,
    };
  }, [pathname, searchParams]);
}
